import { render } from "./ForgotPassword.vue?vue&type=template&id=54415a90&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=54415a90&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54415a90"]])

export default __exports__